module.exports = __webpack_public_path__ + "img/q3_2018.7cee734a.png";